import Vue from "vue";
import VueRouter from "vue-router";


Vue.use(VueRouter);


function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    console.log('Saya masuk')
    next();
  } else {
    next('/login');
  }
}




const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import('../views/Home.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: "/login",
    name: "login",
    component: () => import('../auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },
  // {
  //   path: "/register",
  //   name: "register",
  //   component: () => import('../auth/register.vue'),
  //   beforeEnter: loggedInRedirectDashboard,
  // },

  {
    path: "/about",
    name: "About",
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
    beforeEnter: isLoggedIn,
  },
  // ------------------------ ktp 
  {
    path: "/ktp",
    name: "ktp",
    component: () => import('../views/ktp/ktp.vue'),
    beforeEnter: isLoggedIn,
  },
  // ------------------------ ktp 
  // ------------------------ kartu keluarga
  {
    path: "/kk1",
    name: "kk1",
    component: () => import('../views/kartu_keluarga/kk1.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: "/kk2",
    name: "kk2",
    component: () => import('../views/kartu_keluarga/kk2.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: "/kk3",
    name: "kk3",
    component: () => import('../views/kartu_keluarga/kk3.vue'),
    beforeEnter: isLoggedIn,
  },
  // ------------------------ kartu keluarga
// -----------
    {
      path: "/ppd1",
      name: "ppd1",
      component: () => import('../views/perpindahan_tempat/ppd1.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/ppd2",
      name: "ppd2",
      component: () => import('../views/perpindahan_tempat/ppd2.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/ppd3",
      name: "ppd3",
      component: () => import('../views/perpindahan_tempat/ppd3.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/perubahan_nama",
      name: "perubahan_nama",
      component: () => import('../views/perubahan_nama/perubahan_nama.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/lapor_lahir_mati",
      name: "lapor_lahir_mati",
      component: () => import('../views/pelaporan_kelahiran/lapor_lahir_mati.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/sk_kelahiran",
      name: "sk_kelahiran",
      component: () => import('../views/pelaporan_kelahiran/sk_kelahiran.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/sk_kelahiran_aytdau",
      name: "sk_kelahiran_aytdau",
      component: () => import('../views/pelaporan_kelahiran/sk_kelahiran_aytdau.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/lapor_mati",
      name: "lapor_mati",
      component: () => import('../views/pelaporan_kematian/lapor_mati.vue'),
      beforeEnter: isLoggedIn,
    },



    {
      path: "/f_pencatatan_perceraian",
      name: "f_pencatatan_perceraian",
      component: () => import('../views/formulir_pencatatan_perceraian/f_pencatatan_perceraian.vue'),
      beforeEnter: isLoggedIn,
    },

    {
      path: "/inbox",
      name: "inbox",
      component: () => import('../views/pesan/inbox.vue'),
      beforeEnter: isLoggedIn,
    },

  // ------------------------ MASTER DATA WILAYAH
    {
      path: "/m_provinsi",
      name: "m_provinsi",
      component: () => import('../views/_master data wilayah/provinsi.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/m_kabupaten",
      name: "m_kabupaten",
      component: () => import('../views/_master data wilayah/kabupaten.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/m_kecamatan",
      name: "m_kecamatan",
      component: () => import('../views/_master data wilayah/kecamatan.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/m_kelurahan",
      name: "m_kelurahan",
      component: () => import('../views/_master data wilayah/kelurahan.vue'),
      beforeEnter: isLoggedIn,
    },
    {
      path: "/m_desa",
      name: "m_desa",
      component: () => import('../views/_master data wilayah/desa.vue'),
      beforeEnter: isLoggedIn,
    },
    // ------------------------ MASTER DATA WILAYAH


    // ------------------------ MASTER DATA FORMULIR
      {
        path: "/m_list_agama",
        name: "m_list_agama",
        component: () => import('../views/_master formulir/list_agama.vue'),
        beforeEnter: isLoggedIn,
      },
      {
        path: "/m_list_pekerjaan",
        name: "m_list_pekerjaan",
        component: () => import('../views/_master formulir/list_pekerjaan.vue'),
        beforeEnter: isLoggedIn,
      },
      {
        path: "/m_list_pendidikan",
        name: "m_list_pendidikan",
        component: () => import('../views/_master formulir/list_pendidikan.vue'),
        beforeEnter: isLoggedIn,
      },
      {
        path: "/m_pkl_jenis_kelahiran",
        name: "m_pkl_jenis_kelahiran",
        component: () => import('../views/_master formulir/pkl_jenis_kelahiran.vue'),
        beforeEnter: isLoggedIn,
      },
      {
        path: "/m_pkl_penolong_kelahiran",
        name: "m_pkl_penolong_kelahiran",
        component: () => import('../views/_master formulir/pkl_penolong_kelahiran.vue'),
        beforeEnter: isLoggedIn,
      },
      {
        path: "/m_pkl_tempat_dilahirkan",
        name: "m_pkl_tempat_dilahirkan",
        component: () => import('../views/_master formulir/pkl_tempat_dilahirkan.vue'),
        beforeEnter: isLoggedIn,
      },
      {
        path: "/m_list_shdk",
        name: "m_list_shdk",
        component: () => import('../views/_master formulir/list_SHDK.vue'),
        beforeEnter: isLoggedIn,
      },

      
    // ------------------------ MASTER DATA FORMULIR
    {
      path: "/test_page",
      name: "test_page",
      component: () => import('../views/input.vue'),
      beforeEnter: isLoggedIn,
    },


      {
        path: "/profile",
        name: "profile",
        component: () => import('../views/_profile/profile.vue'),
        beforeEnter: isLoggedIn,
      },

  // ------------------------ MASTER DATA User
    {
      path: "/m_menu_list",
      name: "m_menu_list",
      component: () => import('../views/_master data user/m_menu_list.vue'),
      
    },
    {
      path: "/m_reg_user",
      name: "m_reg_user",
      component: () => import('../views/_master data user/reg_user.vue'),
      
    },
    {
      path: "/m_level_auth",
      name: "m_level_auth",
      component: () => import('../views/_master data user/m_level_auth.vue'),
      
    },
  // ------------------------ MASTER DATA WILAYAH


];

const router = new VueRouter({
  routes,
});

export default router;
